import { useEffect, useState } from "react";

export function useDebug(defaultValue = false) {
  const [debug, setDebug] = useState(() => {
    const savedDebug = localStorage.getItem("kiosk_debug");
    return typeof savedDebug === "boolean" ? savedDebug : defaultValue;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-debug", debug);
  }, [debug]);

  const updateDebug = (newDebug) => {
    setDebug(newDebug);
    localStorage.setItem("kiosk_debug", newDebug);
  };

  return { debug: debug, setDebug: updateDebug };
}